<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="toc"></a><a id="page_vii"><strong>CONTENTS</strong></a></h2><a id="page_vii">
</a><p class="indent"><a id="page_vii"></a><a class="nounder" href="#/xhtml/ch00_fm8_ouver#fm8"><em>Ouverture</em></a></p>
<p class="noindent"><a class="nounder" href="#/xhtml/ch01#ch01"><span class="red">1.</span> Life Is Lived in Episodes and Stages</a></p>
<p class="noindent"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample"><span class="red">2.</span> Choosing a Path: Passion, Talent, and More</span></p>
<p class="noindent"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample"><span class="red">3.</span> The Principle of Enlightened Self-Interest</span></p>
<p class="noindent"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample"><span class="red">4.</span> Of Velvet Gloves, Words, and Handshakes</span></p>
<p class="noindent"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample"><span class="red">5.</span> Paint Yourself Orange</span></p>
<p class="noindent"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample"><span class="red">6.</span> Whose Success?</span></p>
<p class="noindent"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample"><span class="red">7.</span> Fire Your Boss: Leaders and Managers</span></p>
<p class="noindent"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample"><span class="red">8.</span> Zen and the Art of Business(life)</span></p>
<p class="noindent"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample"><span class="red">9.</span> The Not-Always-So-Gentle Art of Coping</span></p>
<p class="noindent"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample"><span class="red">10.</span> (Business)women and Men Are Different</span></p>
<p class="noindent"><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample"><span class="red">11.</span> Eating for Business and Pleasure</span></p>
<p class="noindent"><span class="nounder" href="#/xhtml/ch12#ch12" title="Link target outside of Sample"><span class="red">12.</span> Making It</span></p>
<p class="indent"><span class="nounder" href="#/xhtml/ch13_bm#ch13" title="Link target outside of Sample"><em>Remerciements</em></span></p>
<p class="indent"><span class="nounder" href="#/xhtml/ch14_index#ch14" title="Link target outside of Sample">Index</span></p>
<p class="noindent"><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm6_toc.vue?083b6092